package org.hs_soft.runmynesto.domain.model.home.media_center.tabs.media.media_detail


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class DateInterval(
    @SerialName("from")
    val from: String?,
    @SerialName("to")
    val to: String?,
    @SerialName("__typename")
    val typename: String?
)